var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Inject, Prop } from 'vue-property-decorator';
import { INJECT_UICORE_BUS, INJECT_UICORE_COMPONENT_HOST, INJECT_UICORE_RENDERER } from "../../../lib/utils/consts";
import { escapeSlotName, getCompPathParentInfo } from "../../../lib/utils/layout";
import { cloneDeep, isEqual, set } from "lodash-es";
import { elt } from "../../../lib/utils/browser";
import { isInsideRect } from "../../../lib/utils/styling";
import { getCompPathOf } from "../../../lib/renderer/utils";
let UcSlot = class UcSlot extends Vue {
  constructor() {
    super(...arguments);
    this.internalDefault = [];
  }
  beforeDestroy() {
    this.freeLastDR();
  }
  freeLastDR() {
    var _this$lastDR;
    (_this$lastDR = this.lastDR) === null || _this$lastDR === void 0 || _this$lastDR.$destroy();
    this.lastDR = undefined;
    this.lastDRChildren = undefined;
  }
  async applyDRContent(ev) {
    const {
      designer
    } = this.uc;
    if (!designer) return; // 仅设计模式可用
    let clickedOnItemIndex = -1;
    if (ev) {
      var _this$lastDRChildren, _getCompPathParentInf, _clickedOnVNode$data;
      // 找到当前点击的是第几个元素
      const {
        clientX,
        clientY
      } = ev;
      const clickedOnVNode = (_this$lastDRChildren = this.lastDRChildren) === null || _this$lastDRChildren === void 0 ? void 0 : _this$lastDRChildren.find(x => {
        var _x$elm, _x$elm$getBoundingCli;
        const rect = (_x$elm = x.elm) === null || _x$elm === void 0 || (_x$elm$getBoundingCli = _x$elm.getBoundingClientRect) === null || _x$elm$getBoundingCli === void 0 ? void 0 : _x$elm$getBoundingCli.call(_x$elm);
        return rect && isInsideRect(clientX, clientY, rect);
      });
      clickedOnItemIndex = ((_getCompPathParentInf = getCompPathParentInfo((clickedOnVNode === null || clickedOnVNode === void 0 || (_clickedOnVNode$data = clickedOnVNode.data) === null || _clickedOnVNode$data === void 0 ? void 0 : _clickedOnVNode$data['uc:path']) || '')) === null || _getCompPathParentInf === void 0 ? void 0 : _getCompPathParentInf.index) || 0;
    }
    // Note: 此时可确定当前 renderer === designer.renderer
    const compPath = getCompPathOf(this.renderer, this);
    const slotName = escapeSlotName(this.name);
    await designer.modifyComp(compPath, comp => {
      const content = cloneDeep(this.internalDefault);
      if (slotName === 'default') comp.children = content;else {
        if (!comp.slots) comp.slots = {};
        comp.slots[slotName] = content;
      }
    });
    if (clickedOnItemIndex >= 0) {
      await this.$nextTick();
      designer.compPath = `${compPath}/${slotName}/${clickedOnItemIndex}`;
    }
  }
  get DR() {
    this.freeLastDR();
    const layout = this.internalDefault;
    if (!layout.length) return;
    const defPR = new this.renderer.ucPartialLayoutRenderer({
      parent: this,
      propsData: {
        layout
      }
    });
    this.lastDR = defPR;
    return defPR;
  }
  mounted() {
    const {
      host
    } = this;
    const removeIfMatch = name => {
      if (host.ucSlotInstances[name] === this) delete host.ucSlotInstances[name];
    };
    this.$watch(() => this.name, (n, o) => {
      if (!host.ucSlotInstances) host.ucSlotInstances = {
        [n]: this
      };else host.ucSlotInstances[n] = this;
      if (o) removeIfMatch(o);
    }, {
      immediate: true
    });
    // 由于 $slots 在 Vue2 不是响应式的，所以需要脏一下
    const forceUpdate = () => this.$forceUpdate();
    host.$on('hook:updated', forceUpdate);
    this.$once('hook:beforeDestroy', () => {
      host.$off('hook:updated', forceUpdate);
      removeIfMatch(this.name);
    });
    // 处理默认值的问题
    // （现在 <uc-slot> 支持传入 default="layout" 了
    this.$watch(() => {
      const d = this.default;
      if (!d || typeof d !== 'object') return [];
      if (Array.isArray(d)) return d.filter(x => x && typeof x === 'object');
      return [d];
    }, newValues => {
      if (isEqual(newValues, this.internalDefault || [])) return; // nothing changed
      this.internalDefault = Object.freeze(cloneDeep(newValues));
      forceUpdate();
    }, {
      immediate: true,
      deep: true
    });
  }
  get slotMeta() {
    const {
      beforeDrop,
      allowDeleteChildren,
      isFrozen
    } = this;
    return {
      id: escapeSlotName(this.name),
      type: 'normal',
      beforeDrop: typeof beforeDrop === 'function' ? beforeDrop : () => true,
      allowDeleteChildren: !!allowDeleteChildren,
      frozen: !!isFrozen,
      getSlotContainerElement: () => this.$el,
      ucSlot: this,
      position: this.position
    };
  }
  render(h) {
    let children = this.host.$slots[this.name];
    let usingDefault = false;
    if (!children && this.internalDefault) {
      var _this$DR, _children;
      children = (_this$DR = this.DR) === null || _this$DR === void 0 ? void 0 : _this$DR.getChildrenVNodes();
      if (!((_children = children) !== null && _children !== void 0 && _children.length)) children = undefined;
      this.lastDRChildren = children;
      usingDefault = !!children;
    } else {
      this.freeLastDR();
    }
    children = children || this.$slots.default;
    const divData = {
      class: 'uc-slotForBlocks'
    };
    // 绝对定位插槽 统一patch子元素的样式 + 外壳的样式
    if (this.position === 'absolute') {
      var _children2;
      divData.style = {
        ...divData.style,
        position: 'relative'
      };
      (_children2 = children) === null || _children2 === void 0 || _children2.forEach(vNode => {
        set(vNode, ['data', 'style', 'position'], this.position);
      });
    }
    // 编辑模式下默认插槽的特殊交互
    if (usingDefault && this.uc.isDesignMode && this.uc.designer.renderer === this.renderer) {
      divData.on = {
        ...divData.on,
        // eslint-disable-next-line @typescript-eslint/no-misused-promises
        mousemove: e => showDefaultSlotCover(e, this.uc.designer, this.applyDRContent)
      };
    }
    return h(this.tag, divData, children);
  }
};
__decorate([Prop({
  type: String,
  default: 'default'
})], UcSlot.prototype, "name", void 0);
__decorate([Prop({
  type: String,
  default: 'div'
})], UcSlot.prototype, "tag", void 0);
__decorate([Prop({
  type: Boolean,
  default: false
})], UcSlot.prototype, "isFrozen", void 0);
__decorate([Prop({
  type: Boolean,
  default: true
})], UcSlot.prototype, "allowDeleteChildren", void 0);
__decorate([Prop({
  type: String
})], UcSlot.prototype, "position", void 0);
__decorate([Prop({
  type: [Object, Array],
  default: null
})], UcSlot.prototype, "default", void 0);
__decorate([Prop({
  type: Function,
  default: null
})], UcSlot.prototype, "beforeDrop", void 0);
__decorate([Inject({
  from: INJECT_UICORE_COMPONENT_HOST
})], UcSlot.prototype, "host", void 0);
__decorate([Inject({
  from: INJECT_UICORE_RENDERER
})], UcSlot.prototype, "renderer", void 0);
__decorate([Inject({
  from: INJECT_UICORE_BUS
})], UcSlot.prototype, "uc", void 0);
UcSlot = __decorate([Component({
  name: 'UcSlot',
  ucIsPatchedComponent: true
})], UcSlot);
export { UcSlot };
let defaultSlotContentCover;
function showDefaultSlotCover(e, designer, onApply) {
  if (!defaultSlotContentCover) defaultSlotContentCover = elt('div', {
    class: 'ucd-fullCoverDesignTool ucd-editZone-slotDefaultIndicator',
    'uc-designer-interactive': 'true',
    onmouseleave: () => {
      defaultSlotContentCover.remove();
      defaultSlotContentCover.onpointerdown = null;
    }
  }, [elt('div', {
    class: 'ucd-fullCoverDesignTool-content ucd-editZone-slotIndicator-text'
  }, ['点击解锁，定制插槽内容'])]);
  defaultSlotContentCover.onpointerdown = ev => {
    ev.preventDefault();
    ev.stopPropagation();
    defaultSlotContentCover.remove();
    defaultSlotContentCover.onpointerdown = null;
    onApply(ev);
  };
  designer.editZoneState.placeMask(defaultSlotContentCover, e.currentTarget);
  e.stopPropagation();
  e.preventDefault();
}
//# sourceMappingURL=UcSlot.js.map
